import React from 'react';
import PsFieldError from "./PsFieldError";

export default function RowInput({
  input: { name, onChange, value },
  label,
  meta,
  placeholder,
}) {
  return (
    <div>
      <input
        name={name}
        onChange={onChange}
        value={value}
        type="text"
        placeholder={placeholder || label}
        className={'form-control'}
      />
      <PsFieldError meta={meta} />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/inputs/RowInput.js